import { render, staticRenderFns } from "./EditorContent.vue?vue&type=template&id=6e22f0ec&scoped=true&"
import script from "./EditorContent.vue?vue&type=script&lang=js&"
export * from "./EditorContent.vue?vue&type=script&lang=js&"
import style0 from "./EditorContent.vue?vue&type=style&index=0&id=6e22f0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22f0ec",
  null
  
)

export default component.exports